@if (data$ | async; as data) {
  <app-alerts />

  <app-warehouse-restock-form
    [data]="data"
    [fileUploadVisibility]="fileUploadVisibility()"
    (submitSuccessEvent)="handleSubmitSuccessEvent($event)" />
} @else {
  <app-spinner-filled />
}
